// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__Kv0uZ","content":"LoadingAlert_content__1J49Q"};